<!--
 * @Descripttion: 达人关联的联系人列表
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-04 20:08:34
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-06 15:24:35
-->
<template>
  <el-select :disabled="disabled" v-model="id" :loading-text="loadingText" clearable filterable :loading="loading" remote :remote-method="remoteMethod" @focus="focus" @change="change"  :placeholder="placeholder">
    <template v-slot:prefix>
      <i class="el-icon-search ml-4"></i>
    </template>
    <el-option v-for="(item,index) in options"
        :key="index"
        :value="item.id"
        :label="item.nick_name"
    >
      <item :item="item"></item>
    </el-option>
  </el-select>
</template>
<script>
import { contactList } from "@/api/extenTecord";
import Item from './item';
export default {
  props: {
    value: [String, Number, Array],
    placeholder: {
      type: String,
      default: '请选择 / 搜索联系人'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    anchorId: {
      type: [Number, String],
      default: ''
    },
    unbindWechat: {
      type: [Number, String],
      default: '1'
    }
  },
  data() {
    return {
      id: this.value,
      loadingText: '加载中',
      loading: false,
      options: [],
      imgUrl: 'https://cdn.chaoyongbushou.com/wx/20211108/1636372139805-c010edeb4a822302594d57f1bb6687c.png',
    }
  },
  watch: {
    value(val) {
      this.id = val;
    }
  },
  methods: {
    //远程搜索
    async remoteMethod(e) {
        this.loading = true
        this.loadingText = '加载中';
        const {code,data} = await contactList({anchor_id: this.anchorId, nick_name: e, unbind_wechat: this.unbindWechat})
        this.loading = false
        if(code == 0) {
            this.options = data.list
        }
    },
    async focus(e) {
        this.loading = true
        this.loadingText = '加载中'
        const {code,data} = await contactList({anchor_id: this.anchorId, nick_name: e.target.value, unbind_wechat: this.unbindWechat})
        if(code == 0) {
            this.options = data.list;
            data.list.length ? this.loading = false : this.loadingText = '无数据'
        }
    },
    //选择达人
    change(e) {
      const obj = this.options.find(item => item.id === e);
      this.$emit('input', e);
      this.$emit('change', e , obj);
    },
  },
  components: {
    Item
  }
}
</script>